import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '25',
  height: '23',
  viewBox: '0 0 25 23',
  fill: '#FFF'
}, [
  h('path', {
    d: 'M9 16h7.5v1H9zM15.3 20h4.2v1h-4.2zM15 5h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2c.3 0 .5.2.5.5s-.2.5-.5.5zM19.5 7H14c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5.5c.3 0 .5.2.5.5s-.2.5-.5.5zM19 9h-6.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H19c.3 0 .5.2.5.5s-.2.5-.5.5zM19.5 11h-7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h7c.3 0 .5.2.5.5s-.2.5-.5.5zM18.5 13h-6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h6c.3 0 .5.2.5.5s-.2.5-.5.5zM19 15h-7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h7c.3 0 .5.2.5.5s-.2.5-.5.5zM11 0h12.5v1H11z'
  }),
  h('path', {
    d: 'M13.5 23H1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5c.4 0 .7-.1.9-.3.5-.5.5-1.6.5-2.6 0-1.1 0-2.1.6-2.7.2-.3.6-.4 1-.4h4.6c1-5.5.9-13.9.9-14 0-.7.3-2 1.5-2v1c-.5 0-.5 1-.5 1 0 .4.1 9.1-1 14.6-.1.2-.3.4-.5.4H4c-.2 0-.3.1-.4.1-.3.3-.3 1.2-.3 2 0 1 0 2.1-.4 2.9h10.5c.4 0 .7-.1.9-.3.5-.5.5-1.6.5-2.6 0-1.1 0-2.1.6-2.7.3-.3.6-.4 1.1-.4.5 0 .9.1 1.2.4.5.5.5 1.2.4 1.8 0 .6 0 1.2.3 1.4.2.2.6.3 1.1.3.1 0 .2 0 .5-.2 2-2.1 2.2-13.5 2-17.7 0-.7.3-2 1.5-2C24.9 0 25 2.4 25 3.5c0 .3-.2.5-.5.5H23c0 4.4-.2 14.2-2.4 16.5-.3.4-.7.5-1.2.5-.8 0-1.4-.2-1.8-.6-.6-.6-.6-1.4-.6-2.2 0-.5 0-1-.2-1.1 0-.1-.2-.1-.3-.1-.2 0-.3.1-.4.1-.3.3-.3 1.2-.3 2 0 1.2 0 2.5-.8 3.3-.3.4-.8.6-1.5.6zM23 3h1c-.1-1-.3-1.9-.5-2-.5 0-.5 1-.5 1v1z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/nav-organization-billing.es6.js